var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import SQUserJourney from '@squareup/user-journey-web';
import { logToConsole } from '@dashboard/user-journeys/utils/user-journey-logging';
import env from '@square/environment-utils/environment';
import { captureException, withScope } from '@sentry/ember';
let UserJourney = (_class = class UserJourney extends Service {
  constructor(..._args) {
    super(..._args);
    _initializerDefineProperty(this, "userJourneyData", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _defineProperty(this, "uj", void 0);
    /**
     * Wrapper function around UserJourney methods, to catch and log errors.
     *
     * @param {object} args
     * @param {UJEventName} args.event Name of the UserJourney event
     * @param args.userJourneyAction Underlying UserJourney method to execute
     * @param {string} args.action Name of the action to log with any errors
     */
    _defineProperty(this, "tryExecuteAction", args => {
      const {
        event,
        action,
        userJourneyAction
      } = args;
      if (!this.uj) {
        return undefined;
      }
      try {
        return userJourneyAction();
      } catch (error) {
        withScope(scope => {
          scope.setExtra('error', error);
          captureException(new Error(`Error executing ${action} for user journey ${event}`));
        });
        return undefined;
      }
    });
    if (this.userJourneyData.shouldEnableUserJourneyTracking) {
      this.uj = new SQUserJourney({
        // Should match applicationId here https://docs.google.com/spreadsheets/d/18flx2whKaLmdf3LmJoBoRJzZ86W_fmdK6RBKyjZF2nU/edit?gid=0#gid=0
        applicationId: 'dashboard',
        track: this.userJourneyData.track,
        showLogs: !env().isProduction && !env().isSandbox
      });
    }
  }
  start(event, variant) {
    return this.tryExecuteAction({
      action: 'start',
      event,
      userJourneyAction: () => this.uj?.start(event, variant)
    });
  }
  end(event, outcome, metadata) {
    if (metadata) {
      return this.tryExecuteAction({
        action: 'addBatchMetadataAndEnd',
        event,
        userJourneyAction: () => this.uj?.addBatchMetadataAndEnd(event, metadata, outcome)
      });
    } else {
      return this.tryExecuteAction({
        action: 'end',
        event,
        userJourneyAction: () => this.uj?.end(event, outcome)
      });
    }
  }
  addVariant(event, variant) {
    logToConsole({
      userJourneyName: event,
      action: 'addVariant',
      variant
    });
    return this.tryExecuteAction({
      action: 'addVariant',
      event,
      userJourneyAction: () => this.uj?.setVariant(event, variant)
    });
  }
  addFrustrationSignal(event, frustration) {
    return this.tryExecuteAction({
      action: 'addFrustrationSignal',
      event,
      userJourneyAction: () => this.uj?.addFrustrationSignal(event, frustration)
    });
  }
  addTag(event, tag) {
    return this.tryExecuteAction({
      action: 'addTag',
      event,
      userJourneyAction: () => this.uj?.addTag(event, tag)
    });
  }
  addBatchMetadata(event, metadata) {
    return this.tryExecuteAction({
      action: 'addBatchMetadata',
      event,
      userJourneyAction: () => this.uj?.addBatchMetadata(event, metadata)
    });
  }
  startIfNotStarted(event, variant) {
    if (!this.has(event)) {
      return this.start(event, variant);
    }
    return undefined;
  }
  endIfNotEnded(event, outcome, metadata) {
    if (this.has(event)) {
      this.end(event, outcome, metadata);
    }
    return undefined;
  }
  has(event) {
    return this.uj?.has(event) ?? false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userJourneyData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserJourney as default }; // This is how TypeScript knows how to look up the service.
/** @hidden */